import { faUser } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a User icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/user?f=classic&s=solid
 */
export const UserIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faUser} {...props} />;
};
